import { useNavigate } from 'react-router-dom'
import Pagination from 'components/Pagination/Pagination'
import { useTranslation } from 'react-i18next'
import { trackCtaClick } from 'services/analyticsService'

const RoadMaps = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const casesCustomerExperience = [
    {
      id: 2,
      title: 'roadmaps_page.relatedCases.items.redesenhoDoFluxo.title',
      description: 'roadmaps_page.relatedCases.items.redesenhoDoFluxo.description',
      icon: '',
      url: 'redesenho-do-fluxo',
    },
    {
      id: 3,
      title: 'roadmaps_page.relatedCases.items.serviceDesignSac.title',
      description: 'roadmaps_page.relatedCases.items.serviceDesignSac.description',
      icon: '',
      url: 'service-design-SAC',
    },
    {
      id: 4,
      title: 'roadmaps_page.relatedCases.items.complex.title',
      description: 'roadmaps_page.relatedCases.items.complex.description',
      icon: '',
      url: 'complex',
    },
  ]

  const handleRelatedCaseCtaClick = (caseItem) => {
    const ctaText = t('roadmaps_page.relatedCases.cta')

    trackCtaClick({
      cta_name: 'cx_case_related_case_click',
      cta_location: 'cx_case',
      page_name: 'roadmaps',
      case_title: caseItem.title,
      destination_path: `/${caseItem.url}`,
      cta_text: ctaText,
    })

    navigate(`/${caseItem.url}`)
  }

  return (
    <section className="main-container DataCases">
      <header className="main-container-top">
        <div className="text">
          <h2>{t('roadmaps_page.header.title')}</h2>
        </div>
        <div className="image-container">
          <img
            src="/assets/Cases/DataCases/notebook-datacase2.png"
            alt={t('roadmaps_page.header.imageAlt')}
          />
        </div>
      </header>

      <div className="main-content">
        <div className="main-content-primary">
          <h3 className="NoBorder">{t('roadmaps_page.sections.challenge.title')}</h3>
          <p>{t('roadmaps_page.sections.challenge.description')}</p>

          <h3>{t('roadmaps_page.sections.approach.title')}</h3>
          <ul>
            <li>{t('roadmaps_page.sections.approach.items.item1')}</li>
          </ul>

          <hr />

          <h3>{t('roadmaps_page.sections.result.title')}</h3>
          <ul>
            <li>{t('roadmaps_page.sections.result.items.item1')}</li>
            <li>{t('roadmaps_page.sections.result.items.item2')}</li>
            <li>{t('roadmaps_page.sections.result.items.item3')}</li>
            <li>{t('roadmaps_page.sections.result.items.item4')}</li>
          </ul>

          {/*
          <div className="DataHashtag">
            <button>Data Engineering</button>
            <button>GEN IA</button>
            <button>Full Stack development</button>
            <button>UX</button>
          </div>
          */}
        </div>
      </div>

      <section className="main-cases-container">
        <h2 className="title">{t('roadmaps_page.relatedCases.title')}</h2>
        <span className="subtitle">{t('roadmaps_page.relatedCases.subtitle')}</span>

        <Pagination data={casesCustomerExperience} itemsPerPage={4}>
          {(currentItems) => (
            <div className="main-cases-content">
              {currentItems.map((caseItem) => (
                <article key={caseItem.id} className="case-card">
                  <span className="icon">{caseItem.icon}</span>
                  <h3>{t(caseItem.title)}</h3>
                  <p>{t(caseItem.description)}</p>
                  <a
                    href={caseItem.link}
                    onClick={() => handleRelatedCaseCtaClick(caseItem)}
                  >
                    {t('roadmaps_page.relatedCases.cta')} →
                  </a>
                </article>
              ))}
            </div>
          )}
        </Pagination>
      </section>
    </section>
  )
}

export default RoadMaps
